<template>
  <v-dialog v-model="dialog" :max-width="width">
    <v-card class="white pa-3">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn :small="$vuetify.breakpoint.xsOnly" icon x-large @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="center">
        <div class="primary--text text-left text-md-h4 text-h5 pa-5">{{ $t('onboarding.success_dialog_title') }}</div>
        <div class="text-body-1 text-left pa-5 pb-16">{{ $t('onboarding.success_dialog_text') }}</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name: 'onboarding-success-dialog',
  computed: {
    width() {
      if (this.$vuetify.breakpoint.xlOnly) {
        return '40%'
      } else if (this.$vuetify.breakpoint.lgOnly) {
        return '60%'
      } else if (this.$vuetify.breakpoint.mdOnly) {
        return '75%'
      } else {
        return '95%'
      }
    }
  },
  data() {
    return {
      dialog: true,
    }
  },
  watch: {
    dialog(to, from) {
      if (from && !to) {
        this.$emit('close');
      }
    }
  }
}
</script>
